import { useState, useEffect, useMemo } from "react";
import operationNotPermitted from "../util/operation-not-permitted";

const useOperationNotPermitted = () => {
  const [operationNotPermittedErrorCode, setOperationNotPermittedErrorCode] =
    useState(null);

  const hookId = useMemo(() => Math.floor(Math.random() * 100), []);

  useEffect(() => {
    operationNotPermitted.setCallback({
      hookId,
      setForbidden: (value) => {
        setOperationNotPermittedErrorCode(value);
      }
    });
    return () => {
      operationNotPermitted.removeCallBack(hookId);
    };
  }, [hookId]);

  return operationNotPermittedErrorCode;
};

export default useOperationNotPermitted;
